export function initDataGrail(dataGrailCustomerId: string, dataGrailContainerId: string): void {
  if (!dataGrailCustomerId || !dataGrailContainerId) {
    return;
  }
  const script = document.createElement("script");
  script.src =
    `https://api.consentjs.datagrail.io/${dataGrailCustomerId}` +
    `/${dataGrailContainerId}/consent-loader.js`;
  document.head.appendChild(script);
}
